import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.GET_BUILDING_SUMMARY_FAILURE:
      return {
        title: t('message.title.error.get.building.summary'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.SAVE_FAILURE:
      return {
        title: t('message.title.error.save.building.important.information'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.SAVE_SUCCESS:
      return {
        title: t('message.title.success.save.building.important.information'),
        type: 'success'
      };
    case types.GET_LOCATION_AUTOCOMPLETE_LIST_FAILURE:
      return {
        title: t('message.title.error.get.location.list'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.GET_WATERSHED_ID_BY_LOCATION_FAILURE:
      return {
        title: t('message.title.error.get.watershed.by.location'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    // Duplicated error message with getWatershedById
    case types.GET_WATERSHED_BY_LOCATION_FAILURE:
      return {
        title: t('message.title.error.get.watershed.by.location'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };

    case types.GET_EXPERIMENT_BY_LOCATION_FAILURE:
      return {
        title: t('message.title.error.get.experiment.by.location'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.CREATE_INVENTORIES_QR_STICKERS_PDF_FAILURE:
      return {
        title: t('message.title.error.get.inventory.chemical.product.labels'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };

    default:
      return false;
  }
};
